query GetDocumentPoolDetails($id: UUID!) {
  documentPool(id: $id) {
    id
    name
    description
    defaultDirectoryTypeId
    userGroupId
    defaultDocumentTypeId
    defaultBusinessUnitId
    defaultDepartmentId
    isShareableDefault
    isCreateCopyWithSelection
    isRetainedWithSelection
    isDocumentTypeSelector
    isBusinessUnitSelector
    isDepartmentSelector
    _isDeletable
    _rowTimestamp
    _isProtected
    extractionTypeId
    documentPoolHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    notesByEntityId {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    documentPoolSecureRowLevels {
      id
      name
      description
      securityLevel
    }
    defaultDocumentTypes {
      id
      documentType
      extractionTypes {
        nodes {
          id
          extractionType
        }
      }
    }
  }
}
